import React from "react";
import ReactECharts from "echarts-for-react";

interface DataFunnel {
  eventName: string;
  count: number;
  percent: number;
}

interface EchartsFunnelProps {
  funnelData: DataFunnel[];
}

export const EchartsFunnel: React.FC<EchartsFunnelProps> = ({ funnelData }) => {
  const hasData = funnelData.filter(
    (item) => item.count > 0 || item.percent > 0
  );
  const options = {
    title: {
      text: "",
      left: "center",
      top: 10,
      textStyle: {
        color: "white",
        fontSize: 18,
      },
    },
    tooltip: {
      trigger: "item",
      formatter: ({ name, value }: any) => `${name}: ${value}`,
    },
    legend: {
      show: false,
      orient: "vertical",
      right: 10,
      top: 50,
      textStyle: {
        fontSize: 9,
        color: "white",
        fontWeight: "bold",
      },
      data: funnelData.map((i) => i.eventName),
    },

    animationDuration: 1200,
    animationEasing: "elasticOut",
    series: [
      {
        name: "Funnel %",
        type: "funnel",
        left: "25%",
        width: "60%",
        sort: "none",
        gap: 2,
        min: 0,
        max: 100,
        label: {
          show: true,
          position: "inside",
          formatter: ({ value }: any) => `${value}%`,
          color: "#E3E3E3",
          fontWeight: "bold",
        },
        itemStyle: {
          borderColor: "rgba(255,255,255,0.3)",
          borderRadius: 8,
          shadowBlur: 7,
          shadowColor: "rgba(0,0,0,0.15)",
        },
        data: hasData.map((item) => {
          const color = "#0E364B";
          return {
            name: item.eventName,
            value: item.percent,
            itemStyle: {
              color,
            },
          };
        }),
      },
      {
        name: "Funnel (Conteo)",
        type: "funnel",
        left: "25%",
        width: "15%",
        sort: "none",
        label: {
          show: true,
          position: "left",
          formatter: ({ name, value }: any) => `${name} : ${value}`,
          fontSize: 13,
          color: "#E3E3E3",
          fontWeight: "normal",
        },
        itemStyle: {
          color: "rgba(255,255,255,0)",
          borderColor: "rgba(255,255,255,0)",
        },
        labelLine: {
          lineStyle: {
            type: "dashed",
          },
        },
        data: hasData.map((item) => ({
          name: item.eventName,
          value: item.count,
        })),
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "650px", width: "100%" }} />
  );
};
